"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutContentText = exports.AboutContentLogosContainer = exports.AboutContentTextContainer = exports.AboutContentLogoContentContainer = exports.AboutContentTitle = exports.AboutContentContainer = exports.AboutHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Renderer_1 = require("@kyruus/rich-text/Renderer");
const provider_components_1 = require("@kyruus/provider-components");
exports.AboutHeader = styled_1.default.h2 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
  grid-area: title;
`;
exports.AboutContentContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  line-height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};

  // data can be in plain text (not wrapped in <p> tags) even when summary_data configuration is rich_text
  & div:not(:has(p, ul, ol)) {
    white-space: pre-wrap;
  }
`;
exports.AboutContentTitle = styled_1.default.h4 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  grid-area: title;
`;
exports.AboutContentLogoContentContainer = styled_1.default.div `
  display: grid;
  grid-template-areas:
    'title logos'
    'text logos';
  grid-template-rows: auto;
  grid-template-columns: 1fr ${provider_components_1.PROVIDER_LOGO_MAX_WIDTH_PX_COUNT}px;
  grid-column-gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_small')}) {
    grid-template-areas:
      'title'
      'logos'
      'text';
    grid-template-columns: none;
    grid-row-gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
exports.AboutContentTextContainer = styled_1.default.div `
  grid-area: text;
`;
exports.AboutContentLogosContainer = styled_1.default.div `
  grid-area: logos;
`;
exports.AboutContentText = (0, styled_1.default)((props) => (react_1.default.createElement(Renderer_1.RichTextRenderer, Object.assign({}, props, { styleReset: "revert" /* reset any styling from the consuming context */ })))) `
  &.${Renderer_1.STYLE_RESET_CLASSNAME} {
    p&,
    p,
    h3,
    h4,
    h5,
    h6 {
      margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
      line-height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      white-space: normal;
    }

    ul,
    ol {
      line-height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
      list-style-position: outside;
      padding: 0;
      margin: 0 0 10px 25px;
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      white-space: normal;
    }

    hr {
      margin: 20px 0;
      white-space: normal;
    }

    h6 {
      font-size: 0.75em;
    }
  }
`;
//# sourceMappingURL=provider-about.styles.js.map